<template>
  <div class="row">
    <div class="col-md-12">
      <div class="progress">
        <div
          :class="classForProgress()"
          role="progressbar"
          aria-valuenow="creditsUsed_2"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="'width:' + (100 - (progressValue / totalCredits * 100)) + '%'"
        />
      </div>
    </div>
    <div class="clearfix" />
  </div>
</template>

<script>
import data from "../services/data";

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    progressValue: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      totalCredits: data.totalCredits,
    };
  },
  mounted() {},
  methods: {
    classForProgress: function() {
      if (this.progressValue > 70) {
        return 'progress-bar progress-bar-danger';
      }
      if (this.progressValue > 40) {
        return 'progress-bar progress-bar-warning';
      }
      return 'progress-bar progress-bar-info';
    }
  }
};
</script>

<style>
</style>
